import {useRef, useEffect, Ref} from 'react'

type UseInputFocus = (delay?: number) => Ref<any>

const useInputFocus: UseInputFocus = (delay) => {
  const inputRef = useRef(null)

  useEffect(() => {
    const {current} = inputRef
    if (delay) {
      setTimeout(() => current.focus(), 500)
      return
    }
    current.focus()
  }, []) // eslint-disable-line

  return inputRef
}

export default useInputFocus
